import { render, staticRenderFns } from "./AtenaEdit.vue?vue&type=template&id=03342ae6&scoped=true"
import script from "./AtenaEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./AtenaEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AtenaEdit.vue?vue&type=style&index=0&id=03342ae6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03342ae6",
  null
  
)

export default component.exports